.atm_vy_1osqo2v{width:100%;}
.atm_j6_1ylpe5n{min-height:40px;}
.atm_e2_1ylpe5n{height:40px;}
.atm_9s_1txwivl{display:flex;}
.atm_mk_h2mmj6{position:relative;}
.atm_w8mpmz_glywfm:focus{outline:none;}
.atm_1938jqx_1yyfdc7::after{content:'';}
.atm_t8tx92_1ulexfb::after{display:block;}
.atm_1054lsl_yh40bf::after{height:2px;}
.atm_135rde5_1aemfod::after{background:#146EF5;}
.atm_2zt8x3_stnw88::after{position:absolute;}
.atm_1hhqkaf_1n1ank9::after{bottom:-1px;}
.atm_89ifzh_idpfg4::after{left:0;}
.atm_rxbg8t_gdgrue::after{transition:transform 0.3s ease-out;}
.atm_1hh4tvs_u41gz9::after{width:var(--tab-width);}
.atm_1pbfjna_1v1ngwx::after{opacity:var(--tab-underline-opacity);}
.atm_1sjyuwd_1d6se1k::after{transform:translateX(var(--tab-underline-x));}
.atm_10hypdk_u41gz9 a,.atm_10hypdk_u41gz9 button{min-width:var(--tab-width);}
.atm_k2jgxd_u41gz9.atm_k2jgxd_u41gz9 a,.atm_k2jgxd_u41gz9.atm_k2jgxd_u41gz9 button{flex-basis:var(--tab-width);}
.atm_bx_15xxhlz.atm_bx_15xxhlz{font-family:'DM Sans',sans-serif;}
.atm_c8_1x7uoys.atm_c8_1x7uoys{font-size:0.875rem;}
.atm_7l_6s2ej5{color:#424952;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_rd_glywfm{text-decoration:none;}
.atm_uc_1gunikt{transition:background 0.25s ease-out;}
.atm_19kskpn_118lp2q:hover,.atm_19kskpn_118lp2q:focus{background:#F4F5F7;}
.atm_1lfpgg7_pr0y3d:hover,.atm_1lfpgg7_pr0y3d:focus{color:#32373E;}
.atm_15t0my6_glywfm:hover,.atm_15t0my6_glywfm:focus{outline:none;}
.atm_o1msv6_1aemfod.selected,.atm_o1msv6_1aemfod[aria-selected='true']{color:#146EF5;}
.atm_1vanx1i_1fw03zg.atm_1vanx1i_1fw03zg.selected,.atm_1vanx1i_1fw03zg.atm_1vanx1i_1fw03zg[aria-selected='true']{font-weight:700;}
.atm_wmbeev_pr0y3d.selected:focus::after,.atm_wmbeev_pr0y3d[aria-selected='true']:focus::after{background:#32373E;}
